


const adminRoutes = [
    {
        path: '/admin',
        name: 'admin',
        component: () => import('@/views/Admin/HomeView.vue'),
        redirect: '/admin/dashboard',
        children: [
            {
                path: '/admin/dashboard',
                name: 'admin-dashboard',
                component: () => import('@/views/Admin/Dashboard.vue'),


            },
            {
                path: '/admin/plan',
                name: 'admin-plan',
                component: () => import('@/views/Admin/PlanView.vue'),
            },
            {
                path: '/admin/users',
                name: 'admin-users',
                component: () => import('@/views/Admin/UserView.vue'),
            },




        ]
    },


];

export default adminRoutes;
